<template>
  <div class="yl-search-cjs" ref="cjsSearchRef">
    <div class="top-menu-box">
      <div class="left">
        <slot name="searchBtnTop" />
      </div>
      <el-button class="right" type="text" @click="searchShow = !searchShow">
        <span>{{ searchShow ? $t('收起') : $t('展开') }}</span>
        <el-icon v-if="searchShow"><CaretTop /></el-icon>
        <el-icon v-else><CaretBottom /></el-icon>
      </el-button>
    </div>
    <div
      v-if="searchShow"
      class="form-box"
      :class="hasTagsInput ? 'moreBottom' : ''"
    >
      <slot name="headerSearch" />
    </div>
  </div>
</template>
<script setup>
import {
  getCurrentInstance,
  defineProps,
  defineEmits,
  ref,
  toRefs,
  watch,
  onBeforeMount,
  onMounted,
  onUnmounted
} from 'vue';
import { $t } from '@/plugins/i18n';
import { getClientHeight } from '@/utils/commonFun';

const { proxy } = getCurrentInstance();
const props = defineProps({
  hasTagsInput: {
    // 是否调用TagsInput搜索组件
    type: Boolean,
    default: false
  },
  openCalcTab: {
    // 是否开启自动计算表格高度
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['heightChange', 'emitProxy']);
const searchShow = ref(true);
const { hasTagsInput, openCalcTab } = toRefs(props);

const calcHeight = () => {
  if (openCalcTab.value) {
    setTimeout(() => {
      const height = proxy.$refs['cjsSearchRef'].offsetHeight;
      const clientHeight = getClientHeight();
      // 浏览器高度 - 搜索区域高度 - (fixed-header: 86) - padding：40 - 兼容高度：4
      const tableHeight = clientHeight - height - 86 - 40 - 4;
      proxy.StableHeight = tableHeight;
      emit('heightChange', proxy);
    });
  }
};

// 监听搜索变化 重新计算table高度
watch(searchShow, () => {
  calcHeight();
});

onBeforeMount(() => {
  proxy.StableHeight = '';
  emit('emitProxy', proxy);
});

const myObserver = new ResizeObserver(entries => {
  entries.forEach(() => {
    calcHeight();
  });
});

onMounted(() => {
  const someEl = document.querySelector('.yl-search-cjs');
  myObserver.observe(someEl);
});

onUnmounted(() => {
  myObserver.disconnect();
});
</script>

<style lang="scss">
.yl-search-cjs {
  padding: 10px 20px;
  background-color: #ffffff;
  .top-menu-box {
    display: flex;
    padding: 10px 0;
    background: #fff;
    color: #61666d;
    font-size: 14px;
    .left {
      flex: 1;
    }
    .right {
      width: 100px;
      float: right;
    }
  }
  .moreBottom {
    padding-bottom: 26px;
  }
  .form-box {
    padding: 0 !important;
    background: #fff;
  }
}
</style>
